<section class="meetings-group">
  <ng-template [ngIf]="meetings.length > 1" [ngIfElse]="onlyCard">
    <ng-template [ngIf]="isDragScrollEnabled && isBrowser" [ngIfElse]="responsiveScroll">
      <div class="carousel">
        <ng-template [ngIf]="meetings.length > 2">
          <div class="right-btn" (click)="moveRight()">
            <app-icon class="right-arrow" icon="drag-scroll-arrow"></app-icon>
          </div>

          <div class="left-btn" (click)="moveLeft()">
            <app-icon class="left-arrow" icon="drag-scroll-arrow"></app-icon>
          </div>
        </ng-template>

        <cdk-virtual-scroll-viewport #scroller
                                     [itemSize]="itemSize"
                                     class="scroll-viewport"
                                     orientation="horizontal">
          <div *cdkVirtualFor="let meeting of meetings; let i = index; trackBy: trackByMeetingFn"
               class="scroll-item"
               (click)="onOpenCard(i)">
            <app-meeting-card-half [meeting]="meeting"></app-meeting-card-half>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </ng-template>

    <ng-template #responsiveScroll>
      <div class="responsive-scroll-viewport">
        <div *ngFor="let meeting of meetings; let i = index; trackBy: trackByMeetingFn"
             class="scroll-item"
             (click)="onOpenCard(i)">
          <app-meeting-card-half [meeting]="meeting"></app-meeting-card-half>
        </div>
      </div>
    </ng-template>
  </ng-template>
  <ng-template #onlyCard>
    <div class="only-card-wrap">
      <app-meeting-card *ngFor="let meeting of meetings; trackBy: trackByMeetingFn"
                        [meeting]="meeting">
      </app-meeting-card>
    </div>
  </ng-template>
</section>

<app-modal *ngIf="deviceService.isDesktop() && showModal"
           [canClose]="false"
           (closed)="onCloseModal($event)"
           [prevNext]="true"
           [reachedPrev]="reachedPrev"
           [reachedNext]="reachedNext"
           (togglePrev)="togglePrev($event)"
           (toggleNext)="toggleNext($event)">
  <app-modal-body>
    <app-meeting-card [meeting]="item" [modal]="true" (close)="onCloseCard()"></app-meeting-card>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && showModal" (closed)="onCloseModal($event)">
  <app-mobile-modal-body>
    <div class="card">
      <app-meeting-card [meeting]="item" [modal]="true" (close)="onCloseCard()"></app-meeting-card>
    </div>
  </app-mobile-modal-body>

  <app-mobile-modal-actions></app-mobile-modal-actions>
</app-mobile-modal>
